<template>
  <!-- TODO: create logic with isActive prop for BottomNavigationItems -->
  <SfBottomNavigation id="BootmNav" class="navigation-bottom smartphone-only">
    <SfBottomNavigationItem
      :class="route.path == '/' ? 'sf-bottom-navigation__item--active' : ''"
      icon="home"
      size="20px"
      :label="$t('Home')"
      @click="handleHomeClick"
    />
    <SfBottomNavigationItem
      icon="menu"
      size="20px"
      :label="$t('Items')"
      @click="handleItemsClick"
    />
    <SfBottomNavigationItem
      icon="heart"
      size="20px"
      :label="$t('Wishlist')"
      @click="toggleWishlistSidebar"
    />
    <SfBottomNavigationItem
      icon="profile"
      size="20px"
      :label="$t('Account')"
      @click="handleAccountClick"
    />
    <SfBottomNavigationItem
      icon="message"
      size="20px"
      :label="$t('Message')"
      @click="toggleMessageSidebar"
    >
      <template #icon>
        <SfButton
          aria-label="Toggle message sidebar"
          style="padding: 0;background: none;"
        >
          <SfIcon class="sf-header__icon" icon="message" size="1.25rem" />
          <div class="dian" v-if="unReadNum"></div>
        </SfButton>
      </template>
    </SfBottomNavigationItem>
    <SfBottomNavigationItem
      :label="$t('Basket')"
      icon="add_to_cart"
      @click="openCart"
    >
      <template #icon>
        <SfCircleIcon class="cart-button" aria-label="Add to cart">
          <SfIcon
            icon="add_to_cart"
            color="white"
            size="25px"
            :style="{ margin: '0 0 0 -2px' }"
          />
          <SfBadge v-if="cartTotalItems" class="sf-badge--number cart-badge">{{
            cartTotalItems
          }}</SfBadge>
        </SfCircleIcon>
      </template>
    </SfBottomNavigationItem>
  </SfBottomNavigation>
</template>

<script>
import {
  SfBottomNavigation,
  SfIcon,
  SfCircleIcon,
  SfBadge,
  SfButton,
} from '@storefront-ui/vue';
import { useUiState } from '~/composables';
import { useOCart, useUser, cartGetters, userMessage } from '@bee-hole/coms';
import {
  computed,
  useRoute,
  useRouter,
  onMounted,
} from '@nuxtjs/composition-api';
import { onSSR } from '@vue-storefront/core';

export default {
  components: {
    SfBottomNavigation,
    SfIcon,
    SfCircleIcon,
    SfBadge,
    SfButton,
  },
  setup(props, context) {
    const route = useRoute();
    const router = useRouter();
    const {
      toggleCartSidebar,
      toggleWishlistSidebar,
      toggleLoginModal,
      toggleMobileMenu,
      isMobileMenuOpen,
      toggleSearchItem,
      isSearchItemOpen,
      isMobile,
      toggleMessageSidebar,
    } = useUiState();
    const { isAuthenticated } = useUser();
    const { cart, load } = useOCart();
    const { unResult } = userMessage();
    const handleAccountClick = async () => {
      if (isSearchItemOpen.value) {
        toggleSearchItem();
      }
      if (isAuthenticated.value) {
        const localeAccountPath = context.root.localePath({
          name: 'my-account',
        });
        return router.push(localeAccountPath);
      }
      toggleLoginModal();
    };

    const handleItemsClick = () => {
      toggleMobileMenu();
      // router.push(context.root.localePath("/c/0"));
      if (!isSearchItemOpen.value) {
        return false;
      }
      toggleSearchItem();
    };

    const handleHomeClick = () => {
      isMobileMenuOpen.value ? toggleMobileMenu() : false;
      router.push(context.root.localePath('/'));
      if (!isSearchItemOpen.value) {
        return false;
      }
      toggleSearchItem();
    };

    const cartTotalItems = computed(() => {
      const count = cartGetters.getTotalItems(cart.value);
      return count ? count.toString() : null;
    });
    const openCart = async () => {
      await load();
      toggleCartSidebar();
    };
    onSSR(async () => {
      if (isMobile.value) {
        await load();
      }
    });
    onMounted(async () => {
      if (isMobile.value) {
        await load();
      }
      await load();
    });
    return {
      route,
      isMobileMenuOpen,
      toggleWishlistSidebar,
      toggleCartSidebar,
      toggleMobileMenu,
      cartTotalItems,
      handleAccountClick,
      handleHomeClick,
      handleItemsClick,
      openCart,
      toggleMessageSidebar,
      unReadNum: computed(() => unResult.value?.unread_total_count || 0),
    };
  },
};
</script>
<style lang="scss" scoped>
on-bottom {
  --bottom-navigation-z-index: 9999999999;
}

.cart-button {
  position: relative;
  border: 3px solid #fff;
}

.cart-badge {
  position: absolute;
  top: 0;
  right: 0;
}

.message-badge {
  position: absolute;
  bottom: 70%;
  left: 75%;
}
.dian {
  // position: absolute;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #f00;
  margin-bottom: 10px;
}
</style>
<style lang="scss">
.sf-bottom-navigation {
  --bottom-navigation-z-index: 9999999999;
  z-index: var(--bottom-navigation-z-index);
}

.sf-bottom-navigation-item__label {
  text-align: center;
  min-height: 2rem;
}

#BootmNav {
  .sf-bottom-navigation-item {
    padding: var(--spacer-xs) 0 0 0;
  }

  height: calc(var(--spacer-xs) + 3.75rem);
}
</style>
